import { render, staticRenderFns } from "./main-playing.vue?vue&type=template&id=06d855c6&scoped=true"
import script from "./main-playing.vue?vue&type=script&lang=js"
export * from "./main-playing.vue?vue&type=script&lang=js"
import style0 from "./main-playing.vue?vue&type=style&index=0&id=06d855c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d855c6",
  null
  
)

export default component.exports